/*global site_info */
/**
 * External Dependencies
 */
import 'jquery';
import Common from './common';
import Flex from './flex';

$(document).ready(() => {

    $.fn.isInViewport = function () {
        if (!$(this) || $(this).length < 1 || !$(this).offset()) return false;
        let elementTop = $(this).offset().top;
        let elementBottom = elementTop + $(this).outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    let wistiaLoaded = false;

    function loadWistia() {
        if (wistiaLoaded) return;
        let myScript = document.createElement('script');
        myScript.setAttribute('src', '//fast.wistia.com/assets/external/E-v1.js');
        document.head.appendChild(myScript);
        $(document).off('scroll', loadWistia);
        wistiaLoaded = true;
    }

    if ($('.load-wistia-e-v1').length) {
        const urlParams = new URLSearchParams(window.location.search);
        const hasURLParam = urlParams.get('modal') && urlParams.get('modal') === 'true' && urlParams.get('video-id');
        const hasVideoBackgroundVisible = $('.video-background-wrapper').isInViewport();
        if (hasURLParam || hasVideoBackgroundVisible) {
            loadWistia();
        } else {
            $(document).on('scroll', loadWistia);
            $(window).on('modal-open', loadWistia);
        }
    }

    if ($('*[data-marketo]').length > 0) {
        let myScript = document.createElement('script');
        myScript.setAttribute('src', site_info.marketoScript);
        document.head.appendChild(myScript);
    }

    Common.init();
    Flex.init();
});
